import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const toolsPartsReturnListTodo = createAsyncThunk('toolsPartsReturnList', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + 'tools_parts_issue/store_details',
            params: {
                'ctype': 'I',
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const toolsPartsReturnListSlice = createSlice({
    name: 'toolsPartsReturnList',
    initialState: { data: [] },
    extraReducers: (builder) => {
        builder.addCase(toolsPartsReturnListTodo.fulfilled, (state, action) => {
            if (action?.payload?.status == 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status == 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status == 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }
        });
        builder.addCase(toolsPartsReturnListTodo.rejected, () => { })
    }
})

export default toolsPartsReturnListSlice.reducer;
